import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { formatToZMW, rootUrl } from '../../../helpers';
import { useAuth } from '../../../context/auth-context';
import { FaToggleOn } from 'react-icons/fa';

const Payments = () => {
  const [cashData, setCashData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggle, setToggle] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({
    accountCode: true,
    accountName: true,
    totalBudget: true,
    flexed: true,
    actual: true,
    actualToDate: true,
    performance: true,
    difference: true,
    bPerformance: true,
  });

  const allData = useOutletContext();
  const auth = useAuth();

  var accountCodesAndNames = [
    { id: "151", name: "LOCAL TAXES" },
    { id: "152", name: "FEES AND CHARGES" },
    { id: "153", name: "LICENCES" },
    { id: "154", name: "LEVIES" },
    { id: "155", name: "PERMITS" },
    { id: "156", name: "CHARGES" },
    { id: "157", name: "OTHER INCOMES" },
    { id: "158", name: "NATIONAL SUPPORT (GRANTS)" },
    { id: "159", name: "DONOR SUPPORT" },
    { id: "111", name: "Total" },
    { id: "211", name: "Salaries" },
    { id: "212", name: "Wages" },
    { id: "213", name: "Allowances" },
    { id: "214", name: "Emolument Expenses" },
    { id: "221", name: "Office Costs" },
    { id: "222", name: "Building, Repair and Maintenance Costs" },
    { id: "223", name: "Plant, Machinery, Vehicle Running and Maintenance Costs" },
    { id: "224", name: "Other Administrative Operating Costs" },
    { id: "225", name: "Requisites" },
    { id: "226", name: "Services" },
    { id: "227", name: "Travel Expenses" },
    { id: "228", name: "Training" },
    { id: "229", name: "Legal Costs" },
    { id: "231", name: "Depreciation on Own Assets" },
    { id: "232", name: "Depreciation on Leased Property (Finance Lease)" },
    { id: "241", name: "Interest on Domestic Debt" },
    { id: "242", name: "Interest on External Debt" },
    { id: "243", name: "Financial Charges" },
    { id: "244", name: "Settlement of Outstanding Bills - Financial Charges" },
    { id: "249", name: "Other Financial Charges" },
    { id: "251", name: "Social Assistance Benefits" },
    { id: "261", name: "Grants to Grant-aided Institutions" },
    { id: "262", name: "Grants to Non-Governmental Organisations" },
    { id: "263", name: "Grants to Households" },
    { id: "264", name: "Grants to Institutional Revolving Funds" },
    { id: "265", name: "Other Grants" },
    { id: "267", name: "Other Payments" },
    { id: "271", name: "Subsidies to Non-Financial Enterprises" },
    { id: "272", name: "Subsidies to Financial Institutions" },
    { id: "273", name: "Subsidies to Private Enterprises" },
    { id: "274", name: "Other Subsidies" },
    { id: "281", name: "Legal Expenses" },
    { id: "291", name: "Constitutional Expenditure" },
    { id: "292", name: "Other Constitutional Expenditure" },
    { id: "293", name: "Allowances" },
    { id: "294", name: "Statutory Expenditure" },
    { id: "295", name: "Other Expenses" },
    { id: "311", name: "Fixed Assets" },
    { id: "312", name: "Stocks (Inventories)" },
    { id: "313", name: "Valuables" },
    { id: "314", name: "Non-Produced Assets" },
    { id: "320", name: "Long Term Investments" },
    { id: "321", name: "Debtors" },
    { id: "322", name: "Staff Debtors" },
    { id: "323", name: "Prepayments" },
    { id: "324", name: "VAT refunds" },
    { id: "325", name: "Foreign Debtors" },
    { id: "326", name: "Cash and Cash Equivalents" },
    { id: "411", name: "Creditors" },
    { id: "421", name: "Creditors" },
    { id: "520", name: "Current Year Surplus/(Deficit)" },
    { id: "530", name: "Reserves" },
    { id: "611", name: "Realised Gains/Losses" },
    { id: "621", name: "Unrealised Gains/Losses" },
    { id: "631", name: "Miscellaneous" },
    { id: "510", name: "Owners Fund" },
    { id: "000", name: "Rest" },
  ];
  const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

  useEffect(() => {
    axios
      .get(rootUrl(`/getCash/${auth.user?.cid}`))
      .then((response) => {
        const cash = response.data.data;
        setCashData(cash);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const renderTableRows = () => {
    const rows = [];
    if(!allData.budget){
        return
    }

    

    // const accounts = [...new Set(allData.budget.map(item => item.coa.substring(0, 3)))];
    const accounts = [...new Set(allData.budget.map(item => item.coa))];
    let months = 1;

    let totalBudgetg = 0;
    let totalFlexedg = 0;
    let totalActualg = 0;
    let totalActualToDateg = 0;
    let totalDifferenceg = 0;
    

    accountCodesAndNames.forEach((account) => {
      let totalBudget = 0;
      let totalBudgets = 0;
      let totalFlexed = 0;
      let totalActual = 0;
      let totalActualToDate = 0;
      let totalFlexedPerformance = 0;
      let totalDifference = 0;
      let totalBuggedPerformance = 0;



      accounts.forEach((accountCode) => {
        if (account.id === accountCode.substring(0, 3)) {
          const budgetEntries = allData.budget.filter(item => item.coa === accountCode);
          const coaEntries = allData.coa.filter(item => item.account === accountCode);

          totalBudget = sumOfArray(budgetEntries.map(item => parseFloat(item.price * item.frequency * item.qty)));
          const flexed = (months / 12) * totalBudget;
          const coa = allData.coa.find(item => item.account === accountCode)?.id;
          const actual = sumOfArray(cashData.filter(item => item.coa_id === budgetEntries[0]?.id).map(item => parseFloat(item.amount)));

          if(totalBudget > 0 && !toggle){
            rows.push(
                <tr key={accountCode}>
                   {columnVisibility.accountCode && (
              <td className="border border-gray-300 py-2 px-2">{accountCode}</td>
                  )}
                   {columnVisibility.accountName && (
              <td className="border border-gray-300 py-2 px-2">{coaEntries[0]?.name}</td>
                  )}
                   {columnVisibility.totalBudget && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget)}</td>
                  )}
                  {columnVisibility.flexed && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(flexed)}</td>
                  )}
                   {columnVisibility.actual && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                  {columnVisibility.actualToDate && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(actual)}</td>
                  )}
                   {columnVisibility.performance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / flexed) * 100).toFixed()}%</td>
                  )}
                   {columnVisibility.difference && (
              <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudget - actual)}</td>
                  )}
                  {columnVisibility.bPerformance && (
              <td className="border border-gray-300 py-2 px-2">{((actual / totalBudget) * 100).toFixed()}%</td>
            )}
                </tr>
              );
          }
     
          totalBudgets += totalBudget;
          totalFlexed += flexed;
          totalActual += actual;
          totalActualToDate += actual;
          totalFlexedPerformance += (actual / flexed) * 100;
          totalDifference += totalBudget - actual;
          totalBuggedPerformance += (actual / totalBudget) * 100;
        }
      });


      if(totalBudget > 0){
        rows.push(
            <tr key={`${account.id}-total`} className={`${!toggle?'bg-gray-800 text-white':''} m-2 p-2`} >
            {columnVisibility.accountCode && (
            <td className="border border-gray-300 py-2 px-2">{account.id}</td>
            )}
            {columnVisibility.accountName && (
            <td className="border border-gray-300 py-2 px-2">{account.name}</td>
            )}
            {columnVisibility.totalBudget && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets)}</td>
            )}
            {columnVisibility.flexed && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexed)}</td>
            )}
            {columnVisibility.actual && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActual)}</td>
            )}
            {columnVisibility.actualToDate && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDate)}</td>
            )}
            {columnVisibility.performance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActual / totalFlexed) * 100).toFixed()}%</td>
            )}
            {columnVisibility.difference && (
            <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgets - totalActual)}</td>
            )}
            {columnVisibility.bPerformance && (
            <td className="border border-gray-300 py-2 px-2">{((totalActual / totalBudgets) * 100).toFixed()}%</td>
            )}
            </tr>
          );

        }

          
            totalBudgetg += totalBudgets
            totalFlexedg += totalFlexed;
            totalActualg += totalActual;
            totalActualToDateg += totalActualToDate;
            totalDifference += totalBudgetg - totalActualg;
          

          if(account.id == "111"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-900 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Income'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualg)}</td>
             )}
             {columnVisibility.bPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
         
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

          if(account.id == "000"){
            rows.push(
              <tr key={`${account.id}-total`} className={`bg-blue-900 text-white m-2 p-2`} >
              {columnVisibility.accountCode && (
         <td colSpan={2} className='px-2 py-2 border border-gray-200'>{'Total Expenditure'}</td>
             )}
              
              {columnVisibility.totalBudget && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg)}</td>
             )}
             {columnVisibility.flexed && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalFlexedg)}</td>
             )}
              {columnVisibility.actual && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualg)}</td>
             )}
             {columnVisibility.actualToDate && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalActualToDateg)}</td>
             )}
              {columnVisibility.performance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalFlexedg) * 100).toFixed()}%</td>
             )}
              {columnVisibility.difference && (
         <td className="border border-gray-300 py-2 px-2">{formatToZMW(totalBudgetg - totalActualg)}</td>
             )}
             {columnVisibility.bPerformance && (
         <td className="border border-gray-300 py-2 px-2">{((totalActualg / totalBudgetg) * 100).toFixed()}%</td>
       )}
           </tr>
              );
              totalBudgetg = 0
              totalFlexedg = 0;
              totalActualg = 0;
              totalActualToDateg = 0;
              totalDifference = 0;
          }

        
      

    });

    return rows;
  };

  const handleColumnToggle = (column) => {
    setColumnVisibility((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  return (
    <div className="cash-report">
      <h1 className='font-bold text-2xl my-3'>Receipts and Payments By COA</h1>
      <div className="flex gap-4 mb-4">
        <input
          type="date"
          className="border px-3 py-2 rounded"

        />
        <input
          type="date"
          className="border px-3 py-2 rounded"
 
        />
        <button className='text-white bg-blue-900 p-3 m-2 rounded-lg' onClick={()=>setToggle(!toggle)}> <FaToggleOn/> </button>
      </div>
      <div className='my-5'>
      {Object.keys(columnVisibility).map((column) => (
          <label key={column} className="mr-4">
            <input
              type="checkbox"
              checked={columnVisibility[column]}
              onChange={() => handleColumnToggle(column)}
            />
            {column}
          </label>
        ))}
        </div>
      <table className="table-auto w-full border-collapse border border-gray-300 rounded-lg">
        <thead>
          {/* <tr className='bg-blue-900 text-white'>
            <th className="border border-gray-300 px-4 py-2">Account Code</th>
            <th className="border border-gray-300 px-4 py-2">Account Name</th>
            <th className="border border-gray-300 px-4 py-2">Total Budget</th>
            <th className="border border-gray-300 px-4 py-2">Flexed</th>
            <th className="border border-gray-300 px-4 py-2">Actual</th>
            <th className="border border-gray-300 px-4 py-2">Actual To Date</th>
            <th className="border border-gray-300 px-4 py-2">Flexed Performance</th>
            <th className="border border-gray-300 px-4 py-2">Difference</th>
            <th className="border border-gray-300 px-4 py-2">Budget Performance</th>
          </tr> */}
          <tr className='bg-blue-900 text-white'>
            {columnVisibility.accountCode && (
              <th className="border border-gray-300 py-2 px-2">Account Code</th>
            )}
            {columnVisibility.accountName && (
              <th className="border border-gray-300 py-2 px-2">Account Name</th>
            )}
            {columnVisibility.totalBudget && (
              <th className="border border-gray-300 py-2 px-2">Total Budget</th>
            )}
            {columnVisibility.flexed && (
              <th className="border border-gray-300 py-2 px-2">Flexed</th>
            )}
            {columnVisibility.actual && (
              <th className="border border-gray-300 py-2 px-2">Actual</th>
            )}
            {columnVisibility.actualToDate && (
              <th className="border border-gray-300 py-2 px-2">Actual to date</th>
            )}
            {columnVisibility.performance && (
              <th className="border border-gray-300 py-2 px-2">Actual Performance</th>
            )}
            {columnVisibility.difference && (
              <th className="border border-gray-300 py-2 px-2">Difference</th>
            )}
              {columnVisibility.bPerformance && (
              <th className="border border-gray-300 py-2 px-2">Budget Performance</th>
            )}
          </tr>
        </thead>
        <tbody>
          {renderTableRows()}
        </tbody>
      </table>
    </div>
  );
};

export default Payments;
